<script>
</script>

<div class="formaction" {...$$props}>
  <slot />
</div>
